import { createFileRoute } from '@tanstack/react-router'

import {
  listSearchValidator,
  useListFilters,
} from '@/components/Internal/DataTable'
import { emailLogFilters } from '@/components/Internal/EmailManagement/email-list-filters'
import { EmailLogs } from '@/components/Internal/EmailManagement/EmailLogs'

export const Route = createFileRoute('/internal/system/operations/email/')({
  validateSearch: listSearchValidator(emailLogFilters),
  component: EmailLogsScreen,
})

function EmailLogsScreen() {
  const filters = useListFilters(emailLogFilters, Route)

  return <EmailLogs filters={filters} />
}
